<template>
  <FieldWrapper
    :label="hasSchedule ? '' : label"
    :state="state"
    :configs="configs"
  >
    <template v-if="!hasSchedule">
      <div class="column full-width">
        <div class="col">
          <DatePicker
            v-model="timestamp"
            :placeholder="placeholder"
            :disabled="computedDisabled"
            :type="inputType"
            value-type="timestamp"
            :lang="langPtBR"
            :format="format"
          />
        </div>
      </div>
    </template>

    <template
      v-if="hasSchedule"
      #after
    >
      <div class="row items-end">
        <div class="col-6 schedule-label">
          {{ labelInfo }}
        </div>
        <div
          class="col-6 schedule-label"
          title="Selecione a opção de agendamento"
        >
          Tipo de agendamento
        </div>
      </div>
      <div class="row items-center q-col-gutter-sm">
        <div class="col-6">
          <DatePicker
            v-model="timestamp"
            :placeholder="placeholder"
            :disabled="computedDisabled"
            :disabled-date="disablePastDates"
            :disabled-time="disablePastTime"
            :type="inputType"
            value-type="timestamp"
            :lang="langPtBR"
            :format="format"
          />
        </div>
        <div class="col-6 row no-wrap items-center q-gutter-sm">
          <q-checkbox
            data-testid="campo-data-agendamento-fila"
            :value="scheduleTarget === 'queue'"
            :disable="computedDisabled"
            dense
            size="sm"
            label="Fila"
            @input="setScheduleTarget('queue')"
          />
          <q-checkbox
            data-testid="campo-data-agendamento-agente"
            :value="scheduleTarget === 'agent'"
            :disable="computedDisabled"
            dense
            size="sm"
            label="Agente"
            @input="setScheduleTarget('agent')"
          />
        </div>
      </div>
    </template>
  </FieldWrapper>
</template>

<script>
import FieldWrapper from './FieldWrapper'
import DatePicker from 'vue2-datepicker'
import langPtBR from 'vue2-datepicker/locale/pt-br'
import 'vue2-datepicker/index.css'

const TIME_FORMAT = 'TIME_FORMAT'
const DATE_TIME_FORMAT = 'DATE_TIME_FORMAT'

export default {
  components: {
    DatePicker,
    FieldWrapper
  },

  props: {
    value: {},
    state: {},
    label: {},
    configs: {},
    scheduleTargetValue: {
      default: 'queue'
    },
    hasDialerContact: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    let timestamp = toTimestamp(this.value)
    if (timestamp) timestamp *= 1000

    return {
      langPtBR,
      timestamp,
      scheduleTarget: this.scheduleTargetValue
    }
  },

  computed: {
    hasSchedule () {
      return this.configs?.scheduleSelection === 'yes'
    },

    computedDisabled () {
      return this.disabled || (this.hasSchedule && !this.hasDialerContact)
    },

    isRequired () {
      return ['yes', 'y', 't', 'true', true].includes(this.configs?.fieldRequired)
    },

    labelInfo () {
      return this.isRequired ? `${this.label}*` : this.label
    },

    format () {
      const { fieldTypeInput } = this.configs
      if (fieldTypeInput === TIME_FORMAT) return 'HH:mm:ss'
      if (fieldTypeInput === DATE_TIME_FORMAT) return 'DD/MM/YY HH:mm'
      return 'DD/MM/YYYY'
    },

    placeholder () {
      return this.configs?.placeholder
    },

    inputType () {
      const { fieldTypeInput } = this.configs
      if (fieldTypeInput === TIME_FORMAT) return 'time'
      if (fieldTypeInput === DATE_TIME_FORMAT) return 'datetime'
      return 'date'
    }
  },

  methods: {
    setScheduleTarget (val) {
      if (this.scheduleTarget === val) return
      this.scheduleTarget = val
    },

    disablePastDates (date) {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return date < today
    },

    disablePastTime (date) {
      const now = new Date()
      const isToday = date && date.toDateString() === now.toDateString()
      if (!isToday) return false
      return date < now
    }
  },

  watch: {
    value: {
      deep: true,
      handler (value) {
        let timestamp = toTimestamp(value)
        if (timestamp) timestamp *= 1000
        if (this.timestamp === timestamp) return
        this.timestamp = timestamp
      }
    },

    timestamp: {
      deep: true,
      handler (timestamp) {
        if (this.hasSchedule && timestamp) {
          const now = Date.now()
          if (timestamp < now) {
            this.timestamp = now
            return
          }
        }
        const value = timestamp ? Math.floor(timestamp / 1000) : null
        if (this.value === value) return
        this.$emit('input', value)
      }
    },

    scheduleTarget (val) {
      this.$emit('update:schedule-target', val)
    },

    scheduleTargetValue (val) {
      if (this.scheduleTarget !== val) this.scheduleTarget = val
    }
  }
}

const toTimestamp = (val) => {
  if (!val) return null
  if (typeof val === 'number') return val
  if (val?.getTime()) return Math.floor(val.getTime() / 1000)
  if (isNaN(val)) return null
  return Number(val)
}
</script>

<style lang="sass" scoped>
.schedule-label
  font-size: 12px
  line-height: 16px
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
</style>
